import React from 'react';

const Datenschutz: React.FC = () => (
  <section className="datenschutz">
    <h1>Datenschutzerklärung</h1>

    <h2>1. Allgemeine Hinweise</h2>
    <p>
      Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen. Wir behandeln Ihre
      personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften
      sowie dieser Datenschutzerklärung.
    </p>

    <h2>2. Verantwortliche Stelle</h2>
    <p>
      Kurt Zügner<br />
      Andreas-Hofer-Straße 6<br />
      87452 Altusried<br />
      E-Mail: kurt.zuegner@zgt-ingenieure.de
    </p>

    <h2>3. Erhebung und Speicherung personenbezogener Daten</h2>
    <p>
      Beim Besuch unserer Website werden automatisch Informationen durch den Hosting-Anbieter erfasst
      (sog. Server-Logfiles), wie z.B. IP-Adresse, Browsertyp, Betriebssystem, Referrer-URL und Uhrzeit
      der Serveranfrage. Diese Daten dienen der Gewährleistung eines sicheren Betriebs.
    </p>

    <h2>4. Kontaktaufnahme</h2>
    <p>
      Wenn Sie uns per E-Mail oder Kontaktformular kontaktieren, speichern wir Ihre Angaben zwecks
      Bearbeitung Ihrer Anfrage. Diese Daten werden nicht ohne Ihre Zustimmung weitergegeben.
    </p>

    <h2>5. Cookies</h2>
    <p>
      Unsere Website verwendet nur technisch notwendige Session-Cookies, die nach dem Besuch automatisch
      gelöscht werden.
    </p>

    <h2>6. Webanalyse</h2>
    <p>
      Wir verwenden keine Webanalyse- oder Tracking-Tools wie Google Analytics. Sollten wir ein Tool wie
      Matomo verwenden, würde dies an dieser Stelle beschrieben werden.
    </p>

    <h2>7. Ihre Rechte</h2>
    <p>
      Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung,
      Datenübertragbarkeit und Widerspruch. Kontaktieren Sie uns hierzu unter den oben angegebenen Daten.
    </p>

    <h2>8. Beschwerderecht bei der Aufsichtsbehörde</h2>
    <p>
      Ihnen steht ein Beschwerderecht bei der zuständigen Datenschutzaufsichtsbehörde zu.
    </p>

    <h2>9. SSL- bzw. TLS-Verschlüsselung</h2>
    <p>
      Diese Seite nutzt eine SSL- bzw. TLS-Verschlüsselung, um Ihre Daten sicher zu übertragen.
    </p>

    <h2>10. Änderungen dieser Datenschutzerklärung</h2>
    <p>
      Wir behalten uns vor, diese Datenschutzerklärung zu aktualisieren. Die jeweils aktuelle Version
      finden Sie auf dieser Seite.
    </p>
  </section>
);

export default Datenschutz;
